import { createFileRoute } from '@tanstack/react-router'
import { OrderDetailView } from '@/features/orders/components/order-detail'

// The same order screen, wearing the delivery desk's buttons: the
// receiver's photo, their verified identity, and the record to sign.
function DeliveryOrderDetailPage() {
  const { orderId } = Route.useParams()

  return <OrderDetailView orderId={orderId} mode='delivery' />
}

export const Route = createFileRoute('/_authenticated/delivery-orders/$orderId')({
  component: DeliveryOrderDetailPage,
})
